import React from "react";
import { Col, Row } from "react-bootstrap";

const CertificateDetailRow = ({ heading, content }) => {
  return (
    <Row className="py-1">
      <Col className="general-side-tab-certificate-heading">{heading}:</Col>
      <Col className="general-side-tab-certificate-content">{content}</Col>
    </Row>
  );
};

export default CertificateDetailRow;
